export default __webpack_public_path__ + "static/media/study-light-idea.549bb08b.svg";